/**
 * @generated SignedSource<<556da0df154f4943c406e6fed0bb6d14>>
 * @relayHash a348f2f7f950a8c87c7b77582ff440cf
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-commerce/458.0.0-2024-04-16T08:13:38.881Z/checkoutDeliveryOptionsQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutDeliveryOptionsQuery$variables = {
  city?: string | null;
  country: string;
  currencyConversionRateEventId: string;
  fdfQuoteABTestVariant?: string | null;
  itemId: string;
  quantity?: number | null;
  shouldFetchItemDeliveryOptions: boolean;
  shouldFetchTransactionDeliveryOptions: boolean;
  state?: string | null;
  transactionId?: string | null;
  zipCode?: string | null;
};
export type checkoutDeliveryOptionsQuery$data = {
  readonly viewer: {
    readonly itemDeliveryOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly isLocalPickup: boolean | null;
          readonly serviceId: string | null;
          readonly sourceId: string | null;
          readonly totalAmount: {
            readonly amount: number | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_deliveryOptions" | "checkoutUIActions_deliveryOptions" | "usePreloadedDuties_deliveryOptions">;
        } | null;
      } | null> | null;
    } | null;
    readonly transactionDeliveryOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly isLocalPickup: boolean | null;
          readonly serviceId: string | null;
          readonly sourceId: string | null;
          readonly totalAmount: {
            readonly amount: number | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_deliveryOptions" | "checkoutUIActions_deliveryOptions" | "usePreloadedDuties_deliveryOptions">;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type checkoutDeliveryOptionsQuery = {
  response: checkoutDeliveryOptionsQuery$data;
  variables: checkoutDeliveryOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "country"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currencyConversionRateEventId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fdfQuoteABTestVariant"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "quantity"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchItemDeliveryOptions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchTransactionDeliveryOptions"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v9 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "transactionId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zipCode"
},
v11 = {
  "kind": "Literal",
  "name": "addressResolutionType",
  "value": "ADDRESS"
},
v12 = {
  "kind": "Variable",
  "name": "city",
  "variableName": "city"
},
v13 = {
  "kind": "Variable",
  "name": "country",
  "variableName": "country"
},
v14 = {
  "kind": "Variable",
  "name": "currencyConversionRateEventId",
  "variableName": "currencyConversionRateEventId"
},
v15 = {
  "kind": "Variable",
  "name": "fdfQuoteABTestVariant",
  "variableName": "fdfQuoteABTestVariant"
},
v16 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v17 = {
  "kind": "Literal",
  "name": "isCheckout",
  "value": true
},
v18 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "quantity"
},
v19 = {
  "kind": "Variable",
  "name": "state",
  "variableName": "state"
},
v20 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
},
v21 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocalPickup",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": [
    (v25/*: any*/)
  ],
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuoteEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckoutTransactionQueryRenderer_deliveryOptions"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "checkoutUIActions_deliveryOptions",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "checkoutTransactionReducer_deliveryOptions",
                "selections": [
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": ([]/*: any*/)
              }
            ],
            "args": null,
            "argumentDefinitions": ([]/*: any*/)
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usePreloadedDuties_deliveryOptions"
          },
          (v24/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v28 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "kind": "Variable",
    "name": "transactionId",
    "variableName": "transactionId"
  },
  (v20/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuoteEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentServiceMethod",
            "kind": "LinkedField",
            "name": "serviceMethod",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFreight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceMethodType",
                "storageKey": null
              },
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFreeToBuyer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buyerServiceMethodDisplay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "handlingTimeDisplay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAmount",
            "kind": "LinkedField",
            "name": "buyerTotalAmount",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "kind": "LinkedField",
                "name": "convertedAmountList",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFromDealer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFromInternal",
            "storageKey": null
          },
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showQuoteAsPending",
            "storageKey": null
          },
          (v24/*: any*/),
          (v26/*: any*/),
          (v29/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "checkoutDeliveryOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "shouldFetchItemDeliveryOptions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "itemDeliveryOptions",
                "args": (v21/*: any*/),
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "shouldFetchTransactionDeliveryOptions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "transactionDeliveryOptions",
                "args": (v28/*: any*/),
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v27/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "checkoutDeliveryOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "shouldFetchItemDeliveryOptions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "itemDeliveryOptions",
                "args": (v21/*: any*/),
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v30/*: any*/),
                "storageKey": null
              }
            ]
          },
          {
            "condition": "shouldFetchTransactionDeliveryOptions",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "transactionDeliveryOptions",
                "args": (v28/*: any*/),
                "concreteType": "ShipmentQuoteConnection",
                "kind": "LinkedField",
                "name": "availableDeliveryOptions",
                "plural": false,
                "selections": (v30/*: any*/),
                "storageKey": null
              }
            ]
          },
          (v29/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-commerce/458.0.0-2024-04-16T08:13:38.881Z/checkoutDeliveryOptionsQuery",
    "metadata": {},
    "name": "checkoutDeliveryOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cc56de461fa1087e79e5b1a3fe388b8a";

export default node;
